import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import {
  NotesQueryParams,
  PostCalenderProps,
  PostPonePayloadProps,
} from "src/models/notes.models";
import { OfficeDataProps } from "src/models/office.model";
import { PayloadProps, PutPayloadProps } from "src/models/service.models";
import commonUtils, { urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function addOfficeNotes(data: PayloadProps) {
  return await apiCall.post(API_URL.OFFICE_NOTES.ADD_OFFICE_NOTES, data);
}

export async function addProfessionalNotes(data: PutPayloadProps) {
  return await apiCall.post(
    API_URL.PROFESSIONAL_NOTES.ADD_PROFESSIONAL_NOTES,
    data
  );
}

export async function editOfficeNotes(params: string, data: PutPayloadProps) {
  return await apiCall.patch(
    API_URL.OFFICE_NOTES.EDIT_OFFICE_NOTES + params,
    data
  );
}

export async function editProfessionalNotes(
  params: string,
  data: PutPayloadProps
) {
  return await apiCall.patch(
    API_URL.PROFESSIONAL_NOTES.EDIT_PROFESSIONAL_NOTES + params,
    data
  );
}

export async function revertDns(data: {
  tagged_by: string;
  tagged_user: string;
}) {
  return await apiCall.patch(API_URL.NOTES.DNS_REVERT, data);
}

export async function getDnsLogs(uuid: string, taggedById: string) {
  return await apiCall.get(
    urlReplace(
      urlReplace(
        API_URL.NOTES.GET_DNS_LOGS,
        COMMON_CONSTANTS.TAG_USER_ID,
        uuid
      ),
      COMMON_CONSTANTS.TAG_USER_BY_ID,
      taggedById
    )
  );
}
export async function getDns(
  uuid: string,
  type: number,
  params?: OfficeDataProps
) {
  const url = urlReplace(
    type === CONSTANTS.USER_TYPE.OFFICE.KEY
      ? API_URL.NOTES.OFFICE_DNS_NOTE
      : API_URL.NOTES.PROFESSIONAL_DNS_NOTE,
    COMMON_CONSTANTS.USER.USER_ID,
    uuid
  );
  return await apiCall.get(
    url,
    params as unknown as { [key: string]: string | number | number[] }
  );
}
export async function getNotes(params?: NotesQueryParams) {
  return await apiCall.get(API_URL.NOTES.GET_NOTES, { ...params });
}
export async function getViewNote(uuid: string) {
  const url = urlReplace(
    API_URL.NOTES.VIEW_NOTE,
    COMMON_CONSTANTS.NOTE_UUID,
    uuid
  );
  return await apiCall.get(url);
}

export async function postponeMarkDoneNotes(
  uuid: string,
  payload: PostPonePayloadProps | PostCalenderProps
) {
  const url = commonUtils.getUrlReplace(
    API_URL.NOTES.POSTPONE_MARK_NOTE,
    COMMON_CONSTANTS.NOTE_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export const getOfficeNotes = async (
  uuid: string,
  payload: { [key: string]: string | number | number[] } | undefined
) => {
  const url = API_URL.OFFICE_NOTES.GET_OFFICE_NOTES.replace(
    "officeUuid",
    uuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.get(url, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export const getProfessionalNotes = async (
  uuid: string,
  payload: { [key: string]: string | number | number[] } | undefined
) => {
  const url = API_URL.PROFESSIONAL_NOTES.GET_PROFESSIONAL_NOTES.replace(
    "professionalUuid",
    uuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.get(url, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export async function getContactFind(search: string) {
  return await apiCall.get(API_URL.NOTES.GET_CONTACT_FIND, {
    search,
    include_delete: 1,
  });
}
